import React from 'react';
import { TextField } from '@mui/material';

interface CategoryFieldProps {
    category: string;
    error?: string;
    onChange: (value: string) => void;
}

export const CategoryField: React.FC<CategoryFieldProps> = ({
    category,
    error,
    onChange
}) => {
    return (
        <TextField
            label="Category"
            value={category}
            onChange={(e) => onChange(e.target.value)}
            error={!!error}
            helperText={error || 'Optional category for grouping fee schedules'}
            fullWidth
            size="small"
        />
    );
};
